<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-sheet height="80%" width="80%" class="d-flex" color="transparent">
      <div
        :style="`max-width:${$vuetify.breakpoint.xs ? '100%' : '28.125rem'};width:${
          $vuetify.breakpoint.xs ? '100%' : 'auto'
        };`"
        class="d-flex flex-column justify-space-between">
        <div class="text-uppercase d-inline-flex align-center font-weight-bold title grey--text">
          <v-img max-width="160" height="32" src="/img/brand/Envizion_Logo_CastletonGreen.svg" class="mr-4"></v-img>
        </div>
        <div>
          <div class="display-1 font-weight-bold mt-1">Reset Password!</div>
          <div class="mb-16 mt-1 grey--text title">We will help you reset your password</div>
          <v-form>
            <v-label for="password-field" class="black--text font-weight-medium mt-5 mb-2 d-block"
              >Password</v-label
            >
            <v-text-field
              id="password-field"
              placeholder="************"
              outlined
              v-model="resetForm.password"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
              :rules="[formRules.password]"
              :type="showPassword ? 'text' : 'password'"></v-text-field>
            <v-label for="password-field" class="black--text font-weight-medium mt-5 mb-2 d-block"
              >Confirm Password</v-label
            >
            <v-text-field
              id="password-field"
              placeholder="************"
              outlined
              v-model="resetForm.confirmPassword"
              :append-icon="showPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPasswordConfirm = !showPasswordConfirm"
              :rules="[formRules.confirmPassword(resetForm.password, resetForm.confirmPassword)]"
              :type="showPasswordConfirm ? 'text' : 'password'"></v-text-field>
            <v-btn
              :loading="resetLoading"
              large
              block
              color="black"
              class="text-capitalize white--text mt-2"
              @click="reset"
              >Reset Password <v-icon right>mdi-arrow-right</v-icon></v-btn
            >
          </v-form>
        </div>
        <div class="grey--text mt-1">
          Already have an account?
          <router-link class="text-decoration-none black--text font-weight-medium" to="/login">
            Login Using Your Account</router-link
          >
        </div>
      </div>
      <div class="d-sm-flex pl-16 flex-1 login-img d-none fill-height"></div>
    </v-sheet>
  </div>
</template>

<script>
  import formRules from '@Share/config/form-rules';
  import { mapState } from 'vuex';

  export default {
    name: 'reset-password',
    data() {
      return {
        showPassword: false,
        showPasswordConfirm: false,
        formRules,
        resetForm: {
          id: '',
          password: '',
          confirmPassword: '',
          token: '',
        },
      };
    },
    computed: {
      ...mapState('ACCOUNT', ['resetLoading']),
    },
    methods: {
      reset() {
        this.resetForm.token = this.$route.query.token;
        this.resetForm.id = this.$route.query.id;
        this.$store.dispatch('ACCOUNT/RESET', this.resetForm);
      },
    },
  };
</script>

<style scoped>
  .login-img {
    height: 100%;
    background-image: url('../../../../public/img/forgetPassword.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-origin: content-box;
    background-position: center center;
  }
</style>
